import React from 'react';
import PropTypes from 'prop-types';
import PlyrWithClosedCaptions from '@lwtears/lwt-common-frontend/lib/PlayerWithClosedCaptions';
import { formatPlyrVolume } from 'utils/plyr-util';
import { getLocale } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const VideoPlayer = ({
  sendEvent,
  markTutorialPlayed,
  src,
  caption,
  closedCaptionsSettings,
  showSettings,
  audioSettings,
  description,
  narrationVtt,
  narrationSrc
}) => {
  const handleOnDone = () => {
    sendEvent(true, src, true);
    markTutorialPlayed();
  };

  const PlyrProps = {
    src,
    type: 'video/mp4',
    title: '',
    onload: () => sendEvent(true, src, false),
    onDone: handleOnDone,
    options: {
      autoplay: true,
      withNativeControls: true,
      locale: getLocale(),
      narrationsAsDefault: showSettings,
      showSettings: showSettings,
      captions: {
        active: closedCaptionsSettings.showClosedCaptions,
        styles: { fontSize: closedCaptionsSettings.closedCaptionSize }
      },
      ariaLabel: description
    },
    config: { volume: formatPlyrVolume(audioSettings.volume, audioSettings.muteSounds) },
    captions: [caption],
    narration: {
      src: narrationSrc ?? '',
      captions: [{ src: narrationVtt ?? '', label: '', kind: 'captions' }]
    }
  };
  return <PlyrWithClosedCaptions {...PlyrProps} />;
};

VideoPlayer.propTypes = {
  allowSeek: PropTypes.bool, // atm for native controls only
  src: PropTypes.string, // defaulting to video
  narrationSrc: PropTypes.string,
  narrationVtt: PropTypes.string,
  caption: PropTypes.shape({
    cues: PropTypes.arrayOf(
      PropTypes.shape({
        start: PropTypes.string,
        end: PropTypes.string,
        payload: PropTypes.string // text of caption
      })
    )
  }), // captions file
  autoplay: PropTypes.bool,
  sendEvent: PropTypes.func,
  markTutorialPlayed: PropTypes.func,
  closedCaptionsSettings: PropTypes.object,
  audioSettings: PropTypes.object,
  description: PropTypes.string,
  showSettings: PropTypes.bool
};

export default VideoPlayer;
